import axios from "axios";
import { toast } from "react-toastify";

export const getCachedSilverPrice = async () => {
  const cachedData = localStorage.getItem("silverPriceData");
  const today = new Date().toISOString().split("T")[0];

  if (cachedData) {
    const { pricePerGram, date } = JSON.parse(cachedData);
    if (date === today && pricePerGram) {
      return pricePerGram.toFixed(2);
    }
  }

  try {
    const response = await axios.get("https://api.gold-api.com/price/XAG");
    const pricePerOunce = response.data.price;

    if (!pricePerOunce) throw new Error("Silver price missing from API");

    const pricePerGram = pricePerOunce / 31.1035; // 1 troy ounce = 31.1035 grams

    localStorage.setItem(
      "silverPriceData",
      JSON.stringify({ pricePerGram, date: today })
    );

    return pricePerGram.toFixed(2);
  } catch (error) {
    console.error("Silver price fetch failed:", error);
    toast.error("Failed to fetch silver price.");
    return null;
  }
};
